import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

type cartStatusProps = Parameters<typeof PopulateApiParameter>[0];

addToChainAfter(chain, PopulateApiParameter, props => {
    if (props.needFullCart) {
        props.apiParameter.additionalExpands = [...(props.apiParameter.additionalExpands || []), "allowintegration"];
    }
});
